import { useRef, useState, useEffect, useContext } from 'react';
import axios from '../../axios/Axios.js';
import React from 'react';
import AuthContext from "../../context/AuthProvider";
import styles from './Login.module.scss';
import {BrowserView, MobileView} from 'react-device-detect';
import AlertMessage from "../../components/Alert";
import { isAuthenticated, login } from "../../services/auth";
import {
  Link,
  useNavigate,
} from "react-router-dom";
import { useSnackbar } from 'notistack';

const LOGIN_URL = '/login';

function Login(props) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  useEffect(() => {
    document.title = 'Login';
  }, []);
  const navigate = useNavigate();
  const { setAuth } = useContext(AuthContext);
  const userRef = useRef();
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ username, password }),
        {
        headers: { "Content-Type": "application/json" },
        // withCredentials: true,
        }
    ).then( (res) => {
      const accessToken = res.data.id_token;
      login(accessToken)
      setAuth({ username, accessToken });
      setUsername("");
      setPassword("");
      setSuccess(true);
      setLoading(false);
      navigate('/home');
    }).catch(err => {
      setLoading(false)
      if (!err?.response) {
        enqueueSnackbar('Sem resposta do servidor!', { 
          variant: 'error'
        })
      } else if (err.response?.status === 401) {
        if (err.data?.message) {
          enqueueSnackbar(err.data.message, { 
            variant: 'error'
          });
        } else {
          enqueueSnackbar('Não autorizado!', { 
            variant: 'error'
          });
        };
      } else {
        if(!err?.data.message){
          enqueueSnackbar("Error "+ err?.data.message, { 
            variant: 'error'
          })
        }
        else{
          enqueueSnackbar("Falha no login!", { 
            variant: 'error'
          })
        }
      }
    });
  };

  return (
  <div className={styles.root}>
    {loading && ( // Mostra o componente de loading se o estado for verdadeiro
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <img className={styles.imgLoading} src={require('../../assets/loading.gif')} />
        </div>
      )}
    <BrowserView className={styles.image1}>
    {<img className={styles.image1} src={require('./assets/611e2e6637a49d2d9861a1258d1edf71.png')} alt="alt text" />}
    </BrowserView>
    <div className={styles.box}>
      <div className={styles.flex_col}>
        <img className={styles.image} src={require('./assets/86d5b68e1096185049130f3b34aab905.png')} alt="alt text" />
        <h5 className={styles.highlight}>Entre na sua conta:</h5>
        <div className={styles.text}>Entre com:</div>
        <button disabled className={styles.group}>
          <img className={styles.icon} src={require('./assets/09cbb03227c0fbfaeb1901f8181e66f2.png')} alt="alt text" />
          <pre className={styles.text3}>Sign in with Google</pre>
        </button>

        <div className={styles.text1}>ou</div>

        <form className={styles.flex_col1} onSubmit={handleSubmit}>
          <label className={styles.box1}>
            <div className={styles.info}>
            E-mail
            </div>
          <input
          className={styles.info1}
          type="text"
          name="user"
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Seu e-mail valcann"
          value={username}
          id="user"
          required
          />
          </label>
          <label className={styles.box1}>
            <div className={styles.info}>
            Senha
            </div>
          <input
            className={styles.info1}
            type="password" name="password"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Insira sua senha"
            value={password}
            id="password"
            required
          />
          </label>
          <button className={styles.info2} disabled={!password || !username}>Login</button>
        </form>

        <div className={styles.info3}><Link to="/forgot">Esqueceu sua senha?</Link></div>
        <div className={styles.info3}>
          Ainda não possui uma conta?
          <Link to="/register" className={`${styles.spaceLeft} ${styles.link}`} href="/register">Cadastre-se aqui</Link>
        </div>
      </div>
    </div>
  </div>
);
}

export default Login;
